var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPl12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 31.8 31.8"
    },
    viewBox: "0 0 31.8 31.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 15.9,
    cy: 15.9,
    r: 14.7,
    style: {
      fill: "none",
      stroke: "#222326",
      strokeWidth: 2.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7 21.2c-.1-.1-.1-.3-.2-.5 0-.2-.1-.4-.1-.6-.2.2-.4.3-.6.5-.2.2-.5.3-.7.4-.3.1-.5.2-.9.3-.3.1-.7.1-1 .1-.6 0-1.1-.1-1.6-.3-.5-.2-.9-.4-1.3-.7-.4-.3-.6-.7-.8-1.1-.2-.4-.3-.9-.3-1.4 0-1.2.5-2.2 1.4-2.8.9-.7 2.3-1 4.1-1h1.7v-.7c0-.6-.2-1-.5-1.3-.4-.3-.9-.5-1.6-.5-.6 0-1 .1-1.3.4-.3.3-.4.6-.4 1h-3c0-.5.1-1 .3-1.4.2-.4.5-.8 1-1.2.4-.3.9-.6 1.5-.8.6-.2 1.3-.3 2.1-.3.7 0 1.3.1 1.9.3.6.2 1.1.4 1.6.8.4.3.8.8 1 1.3.2.5.4 1.1.4 1.8v5c0 .6 0 1.1.1 1.5.1.4.2.8.3 1v.2h-3.1zm-2.9-2.1c.3 0 .6 0 .8-.1.3-.1.5-.2.7-.3.2-.1.4-.2.5-.4l.4-.4v-2h-1.5c-.5 0-.9 0-1.2.1-.3.1-.6.2-.8.4-.2.2-.4.3-.5.6-.1.2-.1.5-.1.7 0 .4.1.7.4 1 .3.3.8.4 1.3.4z",
    style: {
      fill: "#222326"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPl12);
export default __webpack_public_path__ + "static/media/pl12.10a443a38efc2c1e9d790a5d2b643b8a.svg";
export { ForwardRef as ReactComponent };